/*
	To do: Refactor this function due to deprication of execCommand.
	* Source: https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand
*/
export default function copyToClipboard() {
	const btn = document.querySelectorAll('.c-copy-to-clipboard__button');
	let valueToCopy;

	if(btn) {
		for(let i = 0; i < btn.length; i++) {
			btn[i].addEventListener('click', function() {
				// get the closest element with .copy-this class
				valueToCopy = btn[i].closest('td').children;
				for (let j = 0; j < valueToCopy.length; j++) {
					if(valueToCopy[j].className === 'contract-number') {

						var tooltip = btn[i].nextElementSibling;
						tooltip.innerHTML = 'Kopierat: <span>' + valueToCopy[j].innerHTML + '</span>';
						var copyArea = document.createElement('div');
						copyArea.setAttribute('contentEditable', true);

						// set to fixed to prevent jump to bottom in Edge
						copyArea.style.position = 'fixed';
						copyArea.style.top = 0;
						copyArea.style.left = 0;

						copyArea.innerHTML = valueToCopy[j].innerHTML;
						document.body.appendChild(copyArea);
						window.getSelection().selectAllChildren(copyArea);
						document.execCommand('copy');
						document.body.removeChild(copyArea);
					}
				}
				btn[i].onmouseout = function() {
					var copyTextOriginal = btn[i].querySelector('.t-visually-hidden').textContent;
					var tooltip = btn[i].nextElementSibling;
					tooltip.innerHTML = copyTextOriginal;
				};
			});
		}
	}
}
